import { z } from 'zod'

export const PiloteTeamMemberRecordZod = z.object({
  id: z.number(),
  role: z.number(),
})
